import React from "react";
import { Box, Card, Typography } from "@mui/material";

const WithdrawRemarks = ({ remarks }: { remarks: string }) => {
  return (
    <>
      {remarks && (
        <Card
          sx={{ mt: 2, boxShadow: "none", border: "1px solid #E7E8E9", pb: 2 }}
        >
          <Box
            className="bg-orange-100"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #E7E8E9",
              py: "8px",
              pl: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "18px",
                lineHeight: "20px",
                color: "#B86D00",
                p: 1,
              }}
              fontWeight="semi-bold"
            >
              Application Withdrawal Reason
            </Typography>
          </Box>
          <Box className="bg-gray-200 p-4 mx-4 mt-4 rounded-md">
            <Typography className="body-m text-gray-700">{remarks}</Typography>
          </Box>
        </Card>
      )}
    </>
  );
};

export default WithdrawRemarks;
